export default function SectionContact() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2 justify-center">
          <div className="w-8 h-8 rounded-lg bg-secondary-100 flex items-center justify-center">
            <i className="ri-mail-send-line text-secondary-600 text-lg"></i>
          </div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950">联系我们</h2>
        </div>
        <p className="text-sm text-foreground-500 mb-8 md:mb-10 text-center">欢迎与我们取得联系，期待您的反馈与建议</p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          <div className="p-5 md:p-6 rounded-xl bg-background-100/80 border border-background-200/60 text-center">
            <div className="w-12 h-12 rounded-xl bg-primary-50 flex items-center justify-center mx-auto mb-3">
              <i className="ri-mail-line text-primary-500 text-xl"></i>
            </div>
            <h3 className="text-sm font-semibold text-foreground-900 mb-1">商务合作</h3>
            <p className="text-xs text-foreground-500">biz@mitaovideo.com</p>
          </div>
          <div className="p-5 md:p-6 rounded-xl bg-background-100/80 border border-background-200/60 text-center">
            <div className="w-12 h-12 rounded-xl bg-accent-50 flex items-center justify-center mx-auto mb-3">
              <i className="ri-chat-3-line text-accent-500 text-xl"></i>
            </div>
            <h3 className="text-sm font-semibold text-foreground-900 mb-1">内容投稿</h3>
            <p className="text-xs text-foreground-500">submit@mitaovideo.com</p>
          </div>
          <div className="p-5 md:p-6 rounded-xl bg-background-100/80 border border-background-200/60 text-center">
            <div className="w-12 h-12 rounded-xl bg-secondary-50 flex items-center justify-center mx-auto mb-3">
              <i className="ri-customer-service-2-line text-secondary-500 text-xl"></i>
            </div>
            <h3 className="text-sm font-semibold text-foreground-900 mb-1">用户反馈</h3>
            <p className="text-xs text-foreground-500">feedback@mitaovideo.com</p>
          </div>
        </div>

        <div className="mt-6 p-5 md:p-6 rounded-xl bg-background-100/80 border border-background-200/60 text-center">
          <p className="text-sm text-foreground-600">
            您也可以通过"用户评价"板块留下观影感受，或在社交媒体上 <strong>@密桃视频</strong> 与我们互动。
            我们珍视每一位影迷的声音，期待与您共同打造更好的观影社区。
          </p>
        </div>
      </div>
    </section>
  );
}